import {defineStore, storeToRefs} from "pinia";
import {computed, ref} from "vue";
import {Offer} from "@/gql/gen";
import {useScopeQuery} from "@/core/store/scopeQuery";
import {useFeatureStore} from "@/modules/feature/store/featrue";

const STORE_NAME = 'offer'

export const useOfferStore = defineStore(STORE_NAME, () => {

    const {registerScopeQuery} = useScopeQuery()
    const featureStore = useFeatureStore()
    const {featuresActiveByCode} = storeToRefs(featureStore)

    const offersState = ref<Offer[]>([])
    const offersStickyHidden = ref<Record<string, number>>({})
    const offersStickyOpened = ref<Record<string, number>>({})

    const offers = computed<OfferModel[]>(() => {
        return offersState.value
    })

    const offersActive = computed<OfferModel[]>(() => {
        return offersState.value.filter((offer => {
            if (offer.FEATURES.length) {
                // return !!offer.FEATURES.find(featureCode => featuresActiveByCode.value[featureCode!])
            }
            return true
        }))
    })

    const offersActiveBanner = computed(() => {
        return offersActive.value
    })

    const offersActiveSticky = computed(() => {
        return offersActive.value.filter((offer => offer.STICKY && !offersStickyHidden.value[offer.ID]))
    })

    const offersStickyOpen = (offerId: number) => {
        offersStickyOpened.value[offerId] = Date.now()
    }

    const offersStickyHide = (offerId: number) => {
        offersStickyHidden.value[offerId] = Date.now()
    }

    registerScopeQuery(STORE_NAME, 'app', {
        offer_common_list: {
            __fragment: 'OfferFields'
        },
    }, (data) => {
        offersState.value = data.offer_common_list as Offer[]
    })

    return {
        offersState,
        offers,
        offersActiveSticky,
        offersActiveBanner,
        offersStickyHidden,
        offersStickyHide,
        offersStickyOpen,
        offersStickyOpened
    }
}, {
    persist: {
        pick: [
            'offersStickyHidden'
        ],
    }
})

export interface OfferModel extends Offer {

}

